import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskInternalNotificationsNextGenRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-internal-notifications-nextGen',
	path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications',
};
